// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBHiYNB709OUntwshgBwlrArmNt9anFw4U",
  authDomain: "welsh-education.firebaseapp.com",
  projectId: "welsh-education",
  storageBucket: "welsh-education.firebasestorage.app",
  messagingSenderId: "52437668556",
  appId: "1:52437668556:web:fc1c6f8cfab8ee09bc2869",
  measurementId: "G-75KW3FHN04"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db }